"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configure = exports.config = void 0;
exports.config = {
    region: undefined,
    publishTopicArn: undefined,
    messageQueueUrl: undefined,
    publishFifoTopicArn: undefined,
    messageFifoQueueUrl: undefined,
    messageGroupId: undefined,
};
const configure = (newConfig) => {
    exports.config = newConfig;
};
exports.configure = configure;
